import { StyleSheet } from "react-native-unistyles";

const stylesheet = StyleSheet.create(({ spacing, colors, border }) => ({
  // Panel holds the settings directly now, so its gap is the between-toggle
  // spacing the sections used internally, not the wider between-section one.
  panel: {
    gap: spacing(5),
  },
  setting: {
    gap: spacing(2),
  },
  hint: {
    color: colors.foregroundDefaultMuted,
  },
  download: {
    gap: spacing(2),
    marginTop: spacing(1),
  },
  progressTrack: {
    height: spacing(1),
    borderRadius: border.radius.full,
    backgroundColor: colors.backgroundSurface,
    overflow: "hidden",
  },
  progressFill: ({ progress }: { progress: number }) => ({
    height: "100%",
    width: `${progress}%`,
    borderRadius: border.radius.full,
    backgroundColor: colors.backgroundPositive,
  }),
}));

export default stylesheet;
